/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Component, ElementRef, Input, OnChanges} from '@angular/core';
import * as d3 from 'd3';

import {LabelledAndColoredDatum} from './chart.interfaces';

/**
 * Pie chart component that renders SVG pie charts with D3.
 */
@Component({
  selector: 'gp-graph-pie-chart',
  template: `
    <div class='chart'></div>`,
  styleUrls: ['./pie-chart.component.css']
})
export class PieChartComponent implements OnChanges {

  @Input() public width: number = 120;

  @Input() public height: number = 120;

  @Input() public data: Array<LabelledAndColoredDatum>;

  private radius: number;

  private svg: any;

  constructor(private elementRef: ElementRef) {
  }

  public render(newValue: any) {

    this.svg = d3.select(this.elementRef.nativeElement.querySelector('.chart')).html('').append('svg')
      .attr('width', this.width)
      .attr('height', this.height)
      .append('g')
      .attr('transform', 'translate(' + this.width / 2 + ',' + this.height / 2 + ')');
    if (!newValue) {
      return;
    }

    this.radius = Math.min(this.width, this.height) / 2;

    const arc = d3.arc<LabelledAndColoredDatum>()
      .outerRadius(this.radius)
      .innerRadius(0);

    const pie = d3.pie<LabelledAndColoredDatum>()
      .value(this.getValue);

    const g = this.svg.selectAll('.arc')
      .data(pie(this.data))
      .enter().append('g')
      .attr('class', 'arc');

    const getColor = (d: any) => this.getColor(d.data);

    g.append('path')
      .attr('d', arc)
      .style('fill', getColor);
  }

  public ngOnChanges() {
    setTimeout(() => this.render(this.data));
  }

  private getValue: (datum: any) => number = (datum: LabelledAndColoredDatum) => datum.value;

  private getColor: (datum: any) => string = (datum: LabelledAndColoredDatum) => datum.color;
}
